// Cabeçalho do site: "Entrar" ou o menu da conta (nome, A minha conta, Sair).
// O menu (Radix + avatar) só é descarregado para quem tem sessão: visitantes anónimos veem só o botão.
import { useMe } from "@ecliptica/api-client/react";
import { useTranslation, type Lang } from "@ecliptica/i18n";
import { Button } from "@ecliptica/ui";
import { lazy, Suspense } from "react";
import { Link } from "react-router";
import { accountPath } from "../lib/lang";

const SignedInMenu = lazy(() => import("./SignedInMenu"));

export function UserMenu({ lang }: { lang: Lang }) {
  const { t } = useTranslation();
  const me = useMe();
  const signIn = (
    <Button asChild size="sm">
      <Link to={accountPath(lang, "signIn")}>{t("nav.signIn")}</Link>
    </Button>
  );
  // Também no HTML pré-renderizado (no servidor ainda não se sabe quem é): botão "Entrar".
  if (!me.data) return signIn;
  return (
    <Suspense fallback={signIn}>
      <SignedInMenu lang={lang} user={me.data.user} />
    </Suspense>
  );
}
